import React, { useEffect, useState } from 'react';
import { FormControl, InputLabel, MenuItem, Select, FormHelperText, Box, Typography, Divider, Stack, Chip } from '@mui/material';

import SiteService from './SiteService'; // Import your service

const MainMeterSelector = ({ mainMeterId, setMainMeterId, setMainMeter }) => {
  const [mainMeters, setMainMeters] = useState([]);
  const [singleMainMeterName, setSingleMainMeterName] = useState('');

  // Fetch main meters when siteId changes
  useEffect(() => {

    SiteService.getMainMetersBySite().then((res) => {
      setMainMeters(res.data);

      if (res.data.length === 1) {
        const mainMeter = res.data[0];
        setMainMeterId(mainMeter.mainMeterId);
        setMainMeter && setMainMeter(mainMeter);
        setSingleMainMeterName(mainMeter.name);
      } else {
        setSingleMainMeterName('');
      }

      if (mainMeterId) {
        const found = res.data.find((m) => String(m.mainMeterId) === String(mainMeterId));
        if (found) {
          setMainMeter && setMainMeter(found);
        }
      }
    });

  }, []);

  //dışarıdan site ve main meter set edildiğinde buna bagli aksionlar çalışmıyordu. tıklamak gerekiyordu
  useEffect(() => {
    if (mainMeterId && mainMeters.length > 0) {
      const selected = mainMeters.find((m) => m.mainMeterId === mainMeterId);
      if (selected) {
        setMainMeter && setMainMeter(selected);
      }
    }
  }, [mainMeterId, mainMeters]);


  return (
    <Box>
      {/* Eğer tek bir ana sayaç varsa */}
      {singleMainMeterName ? (
        <Box display="flex" alignItems="center" mb={2} mt={2} ml={2}>
          <Stack direction="row" spacing={1}>
            <Chip label={` Ana Sayaç: ${singleMainMeterName}`} color="primary" variant="outlined" />
          </Stack>


        </Box>
      ) : (
        <>

          {/* Main Meter Selector */}
          <FormControl sx={{ m: 1, minWidth: 120 }}>
            <InputLabel>Seçilen Ana Sayaç</InputLabel>
            <Select
              value={mainMeterId}
              onChange={(e) => {
                const selectedId = e.target.value;
                setMainMeterId(selectedId);
                const selectedMeter = mainMeters.find((m) => m.mainMeterId === selectedId);
                setMainMeter && setMainMeter(selectedMeter);
              }}
              label="Seçilen Ana Sayaç"
            >
              {mainMeters.map((mainMeter) => (
                <MenuItem key={mainMeter.mainMeterId} value={mainMeter.mainMeterId}>
                  {mainMeter.name}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>Faturanın ana sayacını seçin</FormHelperText>
          </FormControl>
        </>
      )}
    </Box>
  );
};

export default MainMeterSelector;
